module.exports = __webpack_public_path__ + "static/media/jequiti.bccfe8e5.svg";